import { render, staticRenderFns } from "./HelpView.vue?vue&type=template&id=0640df1b&scoped=true&"
import script from "./HelpView.vue?vue&type=script&lang=ts&"
export * from "./HelpView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0640df1b",
  null
  
)

export default component.exports